export enum AuthorityBosch {
  BOSCH_FEATURES_CONFIG_CORE_CREDENTIALS = '21.0.1',
  BOSCH_FEATURES_CREATE_CORE_DIAGNOSTIC = '21.0.2',
}
